import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'
// Initialize analytics with Google Tag Manager
const analytics = Analytics({
  app: 'davood-portfolio',
  plugins: [
    googleTagManager({
      containerId: 'GTM-5ZK3BV2J',
      dataLayerName: 'dataLayer',
    }),
  ],
})
export default analytics
